import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7728df4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content rel"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "alert",
  style: {"line-height":"22px"}
}
const _hoisted_4 = {
  class: "text-ct mb_10",
  style: {"font-weight":"600"}
}
const _hoisted_5 = {
  class: "text-ct mb_20",
  style: {"color":"var(--rcolor)"}
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "flex-cen action mt_20" }

import { ref, computed, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import { isD2C, isEN, isJA, useSite } from '@/store'
import { calc } from '@/util/useYan'
import { changeB2C } from '@/apis/login'
import { bury } from '@/util/useBury'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { formatMoney } from '@/plugins/utils'


export default /*#__PURE__*/_defineComponent({
  props: ['modelValue'],
  emits: ['update:modelValue', 'ok'],
  setup(__props, { emit }) {

const props = __props
const confirm2bJP = 'https://static-jp.theckb.com/static-asset/client/goods/confirm_D2C.jpg'
const confirm2cJP = 'https://static-jp.theckb.com/static-asset/client/goods/confirm_b2b.jpg'
const confirm2bKR = 'https://static-s.theckb.com/BusinessMarket/Client/goods/confirm_b2b_kr.jpg'
const confirm2cKR = 'https://static-s.theckb.com/BusinessMarket/Client/goods/confirm_d2c_kr.jpg'
const confirm2bEN = 'https://static-s.theckb.com/BusinessMarket/Client/goods/confirm_b2b_en.jpg'
const confirm2cEN = 'https://static-s.theckb.com/BusinessMarket/Client/goods/confirm_d2c_en.jpg'



const store = useStore()
const router = useRouter()
const visible = computed({
  get: () => !!(alertVal && props.modelValue),
  set: (v) => emit('update:modelValue', v)
})

const plat = computed(() => store.getters.plat)

const confirmImageSrc = computed(() => {
  let src = ''
  switch (store.getters.site) {
    case 'ko':
      src = isD2C() ? confirm2cKR : confirm2bKR
      break
    case 'ja':
      src = isD2C() ? confirm2cJP : confirm2bJP
      break
    case 'en':
      src = isD2C() ? confirm2cEN : confirm2bEN
      break
  }
  return src
})
let loading = false
const changeTag = async (v: any) => {
  if (loading) return
  bury('ALL_Click_ModeChose')
  if (store.getters.token) {
    loading = true
    changeB2C().then((res) => {
      store.dispatch('route/refreshToken', res.data.token)
    })
  } else {
    router.replace(v.path)
  }
}

const user = computed(() => store.getters.user)
// 等级值 1,2,3,4,5
const level = user.value?.membership?.templateLevel

const site = useSite()

const prices: any = {
  ja: {
    0: {
      name: t('免费会员'),
      month: '0',
      fee: ['5.5', '3', '4', '12.5']
    },
    1: {
      name: t('经济舱'),
      month: '1980',
      fee: ['5.5', '3', '4', '12.5']
    },
    2: {
      name: t('标准舱'),
      month: '9800',
      fee: ['5', '3', '3', '11']
    },
    3: {
      name: t('商务舱'),
      month: '29800',
      fee: ['4', '3', '3', '10']
    },
    4: {
      name: t('头等舱'),
      month: '59800',
      fee: ['3.5', '2', '2', '7.5']
    },
    5: {
      name: t('PRO会员'),
      month: '148000',
      fee: ['3.5', '2', '2', '7.5']
    }
  },
  ko: {
    0: {
      name: t('免费会员'),
      month: '0',
      fee: ['5', '3', '3', '11']
    },
    1: {
      name: t('经济舱'),
      month: '9900',
      fee: ['5', '3', '3', '11']
    },
    2: {
      name: t('商务舱'),
      month: '99000',
      fee: ['4', '3', '3', '10']
    },
    3: {
      name: t('头等舱'),
      month: '259000',
      fee: ['3.5', '2', '2', '7.5']
    },
    4: {},
    5: {}
  },
  en: {}
}[site]

const alert: any = {
  msg1: '月费{price}',
  msg2: 'D2C订单的情况下，购买手续费为{fee1}/个，入库手续费为{fee2}/个，出库手续费为{fee3}/个，总计为{fee4}/个。',
  msg3: '请注意，如果发生这些手续费，可能无法退款。',
  // eslint-disable-next-line space-before-function-paren
  getMsg(type: number) {
    if (type === 1) {
      //
      return t(this.msg1, { price: formatMoney(alertVal.month) })
    } else if (type === 2) {
      //
      const fee = alertVal.fee.map((v: any) => {
        return '<span style="color:var(--rcolor);font-weight:500">' + v + t('元_1') + '</span>'
      }).reduce((fee: any, v: any, i: any) => {
        return Object.assign(fee, { ['fee' + (i + 1)]: v })
      }, {})
      return t(this.msg2, fee)
    } else if (type === 3) {
      //
      return t(this.msg3)
    }
  },
  vals: {
    d2c: prices[level]
  }
}

const alertVal = alert.vals.d2c


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(visible),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    "append-to-body": true,
    top: "25vh",
    width: "800px"
  }, {
    default: _withCtx(() => [
      (_unref(alertVal))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: _unref(confirmImageSrc),
              alt: "",
              class: "confirm-img"
            }, null, 8, _hoisted_2),
            _createElementVNode("div", {
              class: _normalizeClass(!_unref(isD2C)() ? 'hot3 abs' : 'hot1 abs'),
              onClick: changeTag
            }, null, 2),
            (_unref(isJA)())
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass(!_unref(isD2C)() ? 'hot4 abs' : 'hot2 abs'),
                  href: "https://www.theckb.com/price/plan/",
                  target: "_blank"
                }, null, 2))
              : _createCommentVNode("", true),
            (_unref(isD2C)() && !_unref(isEN)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(alertVal).name), 1),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(alert.getMsg(1)), 1),
                  _createElementVNode("div", {
                    class: "mb_10",
                    innerHTML: alert.getMsg(2)
                  }, null, 8, _hoisted_6),
                  _createElementVNode("div", {
                    class: "mb_10",
                    innerHTML: alert.getMsg(3)
                  }, null, 8, _hoisted_7)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_button, {
                type: "default",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("取消")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {emit('update:modelValue', null); emit('ok')})
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("确定")), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})